import { Navigate, Route } from 'react-router';
import { ReportSubType, ReportType } from 'types/CodegenDashboardTypes';

import App from 'App';
import Homepage from 'pages/Homepage';
import Forbidden from 'pages/Forbidden/Forbidden';
import MissingOrganization from 'pages/MissingOrganization/MissingOrganization';
import PlayerReportBatterPage from 'pages/PlayerReport/Batter';
import PlayerReportPitcherPage from 'pages/PlayerReport/Pitcher';
import UmpireReportAdminOverviewPage from 'pages/UmpireReport/AdminOverview/index';
import UmpireReportAllSessionsPage from 'pages/UmpireReport/AllSessions';
import UmpireReportSingleSessionPage from 'pages/UmpireReport/SingleSession';
import SessionReportBatterSinglePage from 'pages/SessionReport/BatterSingle';
import SessionReportBatterPage from 'pages/SessionReport/Batter';
import SessionReportPitcherSinglePage from 'pages/SessionReport/PitcherSingle';
import SessionReportPitcherPage from 'pages/SessionReport/Pitcher';

export type ReportRoute = `/${ReportType}/${ReportSubType}`;

export const ReportRoutes = {
  PlayerReport: {
    Pitcher: '/PlayerReport/Pitcher',
    Batter: '/PlayerReport/Batter',
  },

  UmpireReport: {
    AdminOverview: '/UmpireReport/AdminOverview',
    SingleSession: '/UmpireReport/SingleSession',
    AllSessions: '/UmpireReport/AllSessions',
  },

  SessionReviewReport: {
    BatterSingleSession: '/SessionReviewReport/BatterSingleSession',
    BatterAggregated: '/SessionReviewReport/BatterAggregated',
    PitcherSingleSession: '/SessionReviewReport/PitcherSingleSession',
    PitcherAggregated: '/SessionReviewReport/PitcherAggregated',
  },
} as const satisfies Record<ReportType, Partial<Record<ReportSubType, ReportRoute>>>;

export const DefaultRoutes = {
  Homepage: '/',
  Forbidden: '/forbidden',
  MissingOrganization: '/missing-organization',
  ...ReportRoutes,
} as const;

export const CREATE_PARAM = 'create';

export const routes = (
  <Route element={<App />}>
    <Route path={DefaultRoutes.Homepage} element={<Homepage />} />
    <Route path={DefaultRoutes.Forbidden} element={<Forbidden />} />
    <Route path={DefaultRoutes.MissingOrganization} element={<MissingOrganization />} />

    <Route path={DefaultRoutes.PlayerReport.Batter + '/:reportId'} element={<PlayerReportBatterPage />} />
    <Route path={DefaultRoutes.PlayerReport.Pitcher + '/:reportId'} element={<PlayerReportPitcherPage />} />

    <Route path={DefaultRoutes.UmpireReport.AdminOverview + '/:reportId'} element={<UmpireReportAdminOverviewPage />} />
    <Route path={DefaultRoutes.UmpireReport.SingleSession + '/:reportId'} element={<UmpireReportSingleSessionPage />} />
    <Route path={DefaultRoutes.UmpireReport.AllSessions + '/:reportId'} element={<UmpireReportAllSessionsPage />} />

    <Route path={DefaultRoutes.SessionReviewReport.BatterSingleSession + '/:reportId'} element={<SessionReportBatterSinglePage />} />
    <Route path={DefaultRoutes.SessionReviewReport.BatterAggregated + '/:reportId'} element={<SessionReportBatterPage />} />
    <Route path={DefaultRoutes.SessionReviewReport.PitcherSingleSession + '/:reportId'} element={<SessionReportPitcherSinglePage />} />
    <Route path={DefaultRoutes.SessionReviewReport.PitcherAggregated + '/:reportId'} element={<SessionReportPitcherPage />} />

    <Route path='*' element={<Navigate to={DefaultRoutes.Homepage} replace />} />
  </Route>
);
